import { type RouteObject } from "react-router-dom";
import { AuthGuard } from "./components/layouts/auth-guard";
import { ProductLayout } from "./components/layouts/product-layout";
import { LandingPage } from "./steps/landing-page";
import { ProductRedirect } from "./steps/product-redirect";
import { ShopifyOAuthCallback } from "./steps/shopify-oauth-callback";
import { StepRenderer } from "./steps/step-renderer";

export const routes: RouteObject[] = [
  {
    element: <AuthGuard />,
    children: [
      { path: "/", element: <LandingPage /> },
      { path: "/shopify/callback", element: <ShopifyOAuthCallback /> },
      {
        path: "/:productId",
        element: <ProductLayout />,
        children: [
          { index: true, element: <ProductRedirect /> },
          { path: ":stepPath", element: <StepRenderer /> },
        ],
      },
    ],
  },
];
